import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import { LaunchDarklyFlagKeys } from "@MasterBluePrint/Common/Utilities/LaunchDarklyFlagKeys";
import { EmbedExternalCode } from "@MasterBluePrint/Components/EmbedExternalCode";
import * as React from "react";
import { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

export const productRequestQuoteButtonStyles: ButtonPresentationProps = {
    css: css`
    width: 100%
    `
};

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => {
    const location = getLocation(state);
    const path = location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname;
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    return {
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
    };
}

const styles = productRequestQuoteButtonStyles;

const ProductDetailsRequestQuoteButton = ({
    productContext,
    category
}: Props) => {
    const cantBuy = "product" in productContext ? productContext.product.cantBuy: false;
    const productNumber = "product" in productContext ? productContext.product.productNumber : '';
    const brandName = "product" in productContext ? productContext.product.brand?.name ?? '' : '';
    const categoryPath = category?.path ?? '';
    const featureFlags: string[] = [LaunchDarklyFlagKeys.TEUS_9014];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isFeatureFlag = flagValues[LaunchDarklyFlagKeys.TEUS_9014];
    const [isModalOpen, setIsModalOpen] = useState(false);

    if(!isFeatureFlag || !cantBuy) {
        return null;
    }

    const handleOpenModal = () => {
        setIsModalOpen(true);
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }

    return (
        isFeatureFlag && cantBuy &&
            <>
                <Button {...styles} className="request-quote" id="btnRequestQuote"
                onClick={handleOpenModal}>
                    {translate("REQUEST QUOTE")}
                </Button>
                <Modal
                    headline={translate("Request a Quote")}
                    isOpen={isModalOpen}
                    handleClose={handleCloseModal}
                >
                    <EmbedExternalCode
                        enableThirdPartyCode={true}
                        scriptSrc='//313-KJQ-147.mktoweb.com/js/forms2/js/forms2.min.js'
                        formID='mktoForm_6321'
                        loadFormParam1='//313-KJQ-147.mktoweb.com'
                        loadFormParam2='313-KJQ-147'
                        loadFormParam3='6321'
                        loadFormRedirectUrl='/contact-us/thank-you'
                        partNumber={productNumber}
                        category={categoryPath}
                        brandName={brandName}
                    >
                    </EmbedExternalCode>
                </Modal>
            </>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductDetailsRequestQuoteButton)),
    definition: {
        displayName: "Request a Quote Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
